<template>
  <div class="border bg-light p-3 d-flex justify-content-between align-items-center mb-3"
       :class="{'border-primary': selected, 'cursor-pointer': selectable}"
       @click="$emit('select', paymentMethod)">

    <div class="d-flex align-items-center">
      <div class="d-flex align-items-center">
        <input type="radio" :checked="selected" class="mr-2">
        <b-img :src="cardBrandUrl" class="credit-card-avatar"></b-img>
      </div>

      <div class="d-flex flex-column ml-3">
        <b>{{ paymentMethod.name }}</b>
        <div>**** **** **** {{ paymentMethod.last_four }}</div>
      </div>
    </div>

    <b-button v-if="removable" @click="removePaymentMethod" variant="link" class="p-0">Remove Card</b-button>
  </div>
</template>

<script>
import AssetLoader from "../../../../AssetLoader";

export default {
  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    removable: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    cardBrandUrl: function () {
      return AssetLoader.imagePath(`cards/${this.paymentMethod.brand}.png`);
    }
  },

  methods: {
    removePaymentMethod: function () {
      if (confirm("Are you sure you want to delete this payment method?")) {
        this.$emit('remove', this.paymentMethod)
      }
    }
  }
}
</script>